function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0 -1.059)"
}, /*#__PURE__*/React.createElement("g", {
  id: "coding",
  transform: "translate(0 0.132)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M10.235,9.143l-8-8.723A1.27,1.27,0,0,0,.406.364,1.364,1.364,0,0,0,.354,2.252l7.156,7.807L.354,17.866a1.364,1.364,0,0,0,.053,1.888A1.271,1.271,0,0,0,2.239,19.7l8-8.724A1.365,1.365,0,0,0,10.235,9.143Z",
  transform: "translate(25.412 5.162)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M10.235,17.866,3.08,10.059l7.155-7.807A1.364,1.364,0,0,0,10.181.364,1.27,1.27,0,0,0,8.349.419l-8,8.723a1.365,1.365,0,0,0,0,1.833l8,8.724a1.27,1.27,0,0,0,1.832.054A1.363,1.363,0,0,0,10.235,17.866Z",
  transform: "translate(0 5.162)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M5.259.015a1.3,1.3,0,0,0-1.467,1.13L.015,27.036a1.341,1.341,0,0,0,1.079,1.537,1.268,1.268,0,0,0,.2.015,1.308,1.308,0,0,0,1.271-1.145L6.338,1.552A1.341,1.341,0,0,0,5.259.015Z",
  transform: "translate(14.824 0.926)",
  fill: "#fff"
})));

function SvgShare3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28.588,
    viewBox: "0 0 36 28.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare3);
export default __webpack_public_path__ + "static/media/share3.c943ba78.svg";
export { ForwardRef as ReactComponent };